import thanks1 from "./thanks1";
import thanks2 from "./thanks2";
import thanks3 from "./thanks3";

export default [thanks1, thanks2, thanks3];
